import type { AppDefinition } from '../../types/apps';

export const PongAppDefinition: AppDefinition = {
  appId: 'pong',
  name: 'Pong',
  version: '1.0.0',
  description: 'The classic paddle game — single player against River.',

  entityTypes: [],
  requiresEntity: false,
  requiresProps: false,
  preserveAppInstance: true,

  component: 'pong',

  icon: {
    type: 'phosphor',
    phosphorIcon: 'GameController',
    phosphorWeight: 'duotone',
    color: '#ef4444',
    metadata: {
      source: 'app',
      appId: 'pong',
      isAppIcon: true,
    },
  },

  category: 'games',
  isCore: false,
  isSystem: true,
};

export default PongAppDefinition;
